<template>
  <div>
    <div class="head">
      <!-- 头部 -->
      <div>
        <el-button
          icon="el-icon-s-unfold"
          @click="close"
          type="primary"
          style="margin-left: 10px"
        >
        </el-button>
        <div style="width: 100%" class="drawer">
          <el-drawer :visible.sync="drawer" style="width: 100%" size="75%">
            <div class="imgs">
              <img
                src="../assets/head/logo.png"
                style="height: 27px; width: 115px"
              />
            </div>
            <div>
              <el-tree
                  :data="columnList"
                  :props="defaultProps"
                  accordion
                  @node-click="handleNodeClick"
                  style="height: 40px;">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ node.label }}</span>
      </span>
              </el-tree>
            </div>
          </el-drawer>
        </div>
      </div>
      <!--  @click="$router.push({ name: 'apphome' })" -->
      <div class="img" style="text-align: center">
        <img src="../assets/head/logo.png" alt="" @click="menuChange(0)" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "app-mian-head",
  props: {
    headHour: {},
  },
  watch: {
    headHour(val1, val2) {
      if (val1.top === "-80px") {
        this.close();
      }
    },
  },
  data() {
    return {
      drawer: false,
      schemeList: [],
      productlist: [],
      style: {},
      divINdex: 0,
      imgList: [
        { columnImg: "../assets/head/img.png" },
        { columnImg: "../assets/head/img1.png" },
        { columnImg: "../assets/head/img2.png" },
        { columnImg: "../assets/head/img3.png" },
      ],
      menuShow: false,
      languageShow: false,
      AHour: {
        transform: "translateX(-210px)",
      },
      langHour: {
        transform: "translateX(210px)",
      },
      columnList: [],
      defaultProps: {
        children: "list",
        label: "columnText",
      },
    };
  },
  created() {
    this.getStyle();
    this.getDataList();
    // console.log(this.imgList);
  },
  methods: {
    filterParentByChildType(data) {
      if (!Array.isArray(data)) {
        return []; // 如果传入的不是数组，返回空数组
      }

      return data.filter(item => {
        if (!item || typeof item !== 'object') {
          return false; // 如果当前项不是对象，直接过滤掉
        }

        // 检查是否有子节点，并且子节点是数组
        if (Array.isArray(item.list)) {
          // 检查子节点中是否有 type > 1 的节点（确保 child 存在且 child.type 是数字）
          const hasInvalidChild = item.list.some(child => {
            return child && typeof child.type === 'number' && child.type > 1;
          });

          // 如果子节点中有 type > 1 的节点，则删除整个父节点
          if (hasInvalidChild) {
            return false;
          }

          // 否则递归处理子节点
          item.list = this.filterParentByChildType(item.list);
        }

        // 保留当前节点
        return true;
      });
    },

    getDataList() {
      /*http://article.trilliontrust.com/publish-article/app/article/zhaowulist */
      axios
        .get(
          "https://article.trilliontrust.com/publish-article/sys/column/columnList",
          {}
        )
        .then(({ data }) => {
          if (data && data.code === 0) {
            let listData = data.list.filter(item => {
              return item.id !== 383 && item.id !== 39
            })
            let listDatas = [
              {
                "id": 991,
                "parentId": 0,
                "type": 0,
                "columnText": "公司简介",
                "columnImg": null,
                "createTime": "2022-05-10 09:26:21",
                "updateTime": "2025-07-26 09:15:52",
                "remark": "0",
                "delFlag": "0",
                "publishFlag": "1",
                "siteStatus": 0,
                "orderNum": 1,
                "parentText": null,
              },
              {
                "id": 992,
                "parentId": 0,
                "type": 0,
                "columnText": "加入我们",
                "columnImg": null,
                "createTime": "2022-05-10 09:26:21",
                "updateTime": "2025-07-26 09:15:52",
                "remark": "0",
                "delFlag": "0",
                "publishFlag": "1",
                "siteStatus": 0,
                "orderNum": 1,
                "parentText": null,
              },
              {
                "id": 993,
                "parentId": 0,
                "type": 0,
                "columnText": "新闻动态",
                "columnImg": null,
                "createTime": "2022-05-10 09:26:21",
                "updateTime": "2025-07-26 09:15:52",
                "remark": "0",
                "delFlag": "0",
                "publishFlag": "1",
                "siteStatus": 0,
                "orderNum": 1,
                "parentText": null,
              }
            ]
            this.columnList = this.filterParentByChildType(listData).concat(listDatas)
            return
            let index=data.list.findIndex(item => item.id == 910)
            if (index != -1){
              data.list.splice(index,1)
            }
            data.list.forEach((item,index)=>{
              data.list[index].remark == "支持基于门限签名的密钥管理"?data.list.splice(index,1):null
            })
            this.columnList=[]
            for (let i = 0; i < 9; i++) {
              this.$set(this.columnList, i, {
                label: data.list[i].columnText,
                children: [],
              });
              // 二级目录
              for (let l = 0; l < data.list[i].list.length; l++) {
                if (data.list[i].id != 939 && data.list[i].id != 911 && data.list[i].id != 919 &&  data.list[i].id != 952 &&  data.list[i].id != 963) {
                  this.$set(this.columnList[i].children, l, {
                    label: data.list[i].list[l].columnText,
                    children: [],
                  });
                }
                // 三级目录
                for (let n = 0; n < data.list[i].list[l].list.length; n++) {
                  if (data.list[i].id != 939 && data.list[i].id != 911 && data.list[i].id != 919 &&  data.list[i].id != 952 &&  data.list[i].id != 963){
                    this.$set(this.columnList[i].children[l].children, n, {
                      label: data.list[i].list[l].list[n].columnText,
                    });
                  }
                }
              };
            }

            this.columnList.forEach((item,index)=>{
              if (item.label=="应用场景" || item.label=="概述"){
                this.columnList.splice(index,1)
              }
              if (item.label=="关于我们"){
                this.columnList[index].children[0].children=[]
                this.columnList[index].children[1].children=[]
                this.columnList.splice(index,0,{
                  label: "新闻动态",
                })
              }
            })
            this.columnList.shift()
            this.columnList.push(
                {
                  label: "加入我们",
                }
            );

          }
          else {

          }

        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getStyle() {
      for (let i = 0; i < this.schemeList.length; i++) {
        for (let l = 0; l < this.schemeList[i].text.length; l++) {
          this.$set(
            this.style,
            "style" + i + l,
            "margin-right: 10px;cursor: pointer"
          );
        }
      }

      for (let i = 0; i < this.productlist.length; i++) {
        for (let l = 0; l < this.productlist[i].text.length; l++) {
          this.$set(
            this.style,
            "style" + i + l,
            "margin-right: 10px;cursor: pointer"
          );
        }
      }
    },
    mouseover(index, indexs) {
      this.style["style" + index + indexs] =
        "margin-right: 10px;cursor: pointer;color:#000";
    },
    Productservice(item, items) {
      if (item == undefined) {
        item = this.productlist[0].columnText;
        items = this.productlist[0].list[0].columnText;
      } else {
        item = item.columnText;
      }
      this.$router.push({
        name: "scheme-app",
        query: {
          item: item,
          text: items,
          time: new Date().getTime(),
        },
      });
    },
    mtassets(item, items) {
      if (item == undefined) {
        axios
          .get(
            "https://article.trilliontrust.com/publish-article/sys/column/byName?text=" +
              this.schemeList[0].list[0].columnText,
            {}
          )
          .then(({ data }) => {
            if (data && data.code === 0) {
              this.$router.push({
                name: "mtevidence-app",
                query: {
                  item: data.list[0].parentText,
                  text: data.list[0].columnText,
                  time: new Date().getTime(),
                },
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.$router.push({
          name: "mtevidence-app",
          query: {
            item: item.columnText,
            text: items,
            time: new Date().getTime(),
          },
        });
      }
    },
    news() {
      this.$router.push({
        name: "news-app",
      });
    },
    about() {
      this.$router.push({
        name: "about-app",
      });
    },
    recruitment() {
      this.$router.push({
        name: "recruitment-app",
      });
    },
    // 表头按钮，点击图片以及其他的按钮
    menuChange(index) {
      // this.menuShow = false
      this.AHour = {
        transition: "all 500ms",
        transform: "translateX(-210px)",
        cursor: "pointer",
      };
      this.$emit("returenText", { index: index });

      this.$router.push({
        name: "home-app",
      });
    },
    menuClick() {
      this.AHour = {
        transition: "all 500ms",
        transform: "translateX(0px)",
        cursor: "pointer",
      };
    },
    close() {
      // this.menuShow = false
      this.drawer = true;
      this.AHour = {
        transition: "all 500ms",
        transform: "translateX(-210px)",
        cursor: "pointer",
      };
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleNodeClick(data, data2, data3) {
      if (data.columnText === "公司简介") {
        this.$router.push({
          name: 'about',
        });
      }else if (data.columnText === "加入我们") {
        this.$router.push({
          name: "recruitment",
        });
      }else if (data.columnText === "新闻动态") {
        this.$router.push({
          name: "news",
        });
      }else if (data.columnText === "区块链产品演示") {
        this.$router.push({
          name: "demonstration_mobile",
          query: {
            item: data.columnText,
            text: data.columnText,
            time: new Date().getTime(),
          },
        });
      }else if (data.list.length<=0) {
        this.$router.push({
          name: "mtevidence",
          query: {
            item: data.columnText,
            text: data.columnText,
            time: new Date().getTime(),
          }
        });
      }
      return
      if (data.label === "公司简介") {
        // this.$router.query.name;
        this.$router.push({
          name: 'about_mobile',
          // query: {
          //   name: data.label,
          // },
        });
      }
      if (data.label === "加入我们") {
        this.$router.push({
          name: "recruitment_mobile",
        });
      }
      if (data.label === "新闻动态") {
        this.$router.push({
          name: "news_mobile",
        });
      }
      if (data2.parent.data.label === "区块链产品演示") {
        this.$router.push({
          name: "demonstration_mobile",
          query: {
            item: data2.parent.data.label,
            text: data.label,
            time: new Date().getTime(),
          },
        });
      }
      if (data2.parent.parent!=null) {
        if (data2.parent.parent.data.label === "区块链解决方案") {
          this.$router.push({
            name: "mtevidence_mobile",
            query: {
              item: data2.parent.data.label,
              text: data.label,
              time: new Date().getTime(),
            }
          });
        }
        if (data2.id == 65) {
          window.open("https://mpdatatrading-admin.trilliontrust.com/login?redirect=%2Findex")
        } else if (data2.id == 66) {
          window.open("https://mpdatatrading.trilliontrust.com/#/home")
        }
      }
      if (data.label === "空天地海潜一体柔性复合防御无人值守集群平台" || data.label == "可信数据空间产品系列" || data.label == "国产自主可控联盟链基础设施产品" ||  data.label == "异构无人集群自主多域作战弹性指控平台产品" || data.label == "保障仿真筹划管控运维系统产品" || data.label == "兆感：空天地海潜一体柔性复合防御无人值守集群平台" || data.label == "采购链接" || data.label == "荣誉资质" || data2.id == 52 || data2.id == 64) {
        document.documentElement.scrollTop = 0;
        this.$router.push({
          name: data.label == "采购链接"?"purchase_mobile":"scheme_mobile",
          query: {
            item: data2.parent.data.label == undefined?data.label:data2.parent.data.label,
            text: data.label,
            time: new Date().getTime(),
          },
        });
      }
      // if (data.label === "产品演示") {
      //   this.$router.push({
      //   name: "demonstration",
      // });
      // }

    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-tree-node{
  white-space:wrap;
}
.head {
  // min-width: 100%;
  width: 100%;
  height: 70px;
  background-color: white;
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 2022;//优先级
  top: 0;
  // float: left;
  .drawer {
    position: relative;
    .imgs {
      position: absolute;
      top: 20px;
      left: 20px;
      z-index: 2;
    }
  }
  .img {
    margin-left: 18%;
    img {
      height: 27px;
      float: left;
    }
  }

  .navigation {
    // margin-left: 83px;

    ul {
      display: flex;

      li {
        position: relative;
        margin-right: 47px;
        margin-top: 0;

        .navigation-button {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #6e6d7a;
          cursor: pointer;
          &:hover {
            color: #313141;
          }
        }

        .radius {
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          border-radius: 50%;
          width: 6px;
          height: 6px;
          background: #0069fd;
        }

        .el-drawer.rtl {
          width: 75%;
        }
      }
    }
  }
  /deep/ .el-drawer__header {
    height: 30px;
    padding: 20px;
    margin-bottom: 0px;
  }
}

/deep/ .el-tree-node__content {
  height: 45px;
}
</style>
